import { message } from "antd";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, CustomSelect, CustomDragger, ModalTooltip } from "../../../components";
import { createManyStudens, } from "../../../redux/VRL/thunks";

export const AddUsersByFile = ({ close }) => {
    const [selectMateria, setSelectItem] = useState(null);
    const [arrayFile, setArrayFile] = useState([]);
    const { groups, } = useSelector((state) => state.vrlSlice);
    const dispatch = useDispatch();

    const onSubmit = async () => {

        const students = arrayFile.map((student) => {
            if (student[0]) {
                return {
                    userId: student[0].trim(),
                    name: student[1].trim(),
                };
            }
            else {
                return {}
            }
        });
        const response = await dispatch(createManyStudens({ students, learningGroupId: selectMateria }));
        if (response.status === 0) {
            message.success("Los alumnos se han creado con exito");
            close();
        } else {
            message.error("Error en la creacion de los alumnos: " + response.payload[0].msg);
        }
    };

    return (
        <Formik
            initialValues={{
                userName: "",
                matricula: "",
                FormType: "0",
            }}
            // validationSchema={validationLogin}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, handleChange, values }) => (
                <Form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-[1fr] px-4">
                        <div className="flex justify-start pt-3 flex-col pb-2">
                            <p className="mb-2 text-base font-medium text-686868 mt-4">Grupo</p>
                            {groups.length > 0 && (
                                <CustomSelect

                                    items={groups}
                                    label="Elige el grupo donde subirás el archivo"
                                    change={setSelectItem}
                                />
                            )}
                            <div className="flex items-center mt-4 mb-2">
                                <p className="text-base font-medium text-686868 mr-2">Archivo</p>
                                <ModalTooltip
                                    title={
                                        "El archivo debe de ser un documento .csv que incluya solo dos columnas: matrículas en la primera y nombre completo en la segunda. No se debe incluir ninguna cabecera en el archivo."
                                    }
                                    placement={"right"}
                                    color={"#3366FF"}
                                />
                            </div>
                            <div className="pb-6">

                                <CustomDragger
                                    callback={(array) => {
                                        setArrayFile(array);
                                    }}

                                />
                            </div>
                        </div>
                        <div className="absolute left-0 bottom-0 h-[40px] pb-8 w-full flex justify-end items-center px-4 pl-4">
                            <Button text="Cancelar" isPrincipal={false} onClick={close} />
                            <div className="w-4"></div>
                            <Button text="Guardar" isPrincipal={true} onClick={handleSubmit} />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
